

export default function RestrictedView({userType = [], permission= ['*'], children}) {
  const currentPermission = localStorage.getItem("permission");
  const currentTypeUser = localStorage.getItem("type_user");
  return ((!userType.length || userType.includes(currentTypeUser)) 
          && (permission == null || permission.includes(currentPermission)) 
          && children);
}